// const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwidXJpIjoibW9uZ29kYjovL3BheW1ldGVybWluYWxzOnBheW1ldGVybWluYWxzQHBheW1lbW9iaWxlLmZyOjI3MDE3Lz9kaXJlY3RDb25uZWN0aW9uPXRydWUmYXV0aFNvdXJjZT1wYXltZW1vYmlsZSIsImlhdCI6MTcwNTY2ODc0NiwiZXhwIjoxNzY4NzgzOTQ2fQ.hhGh8FgjaKzadmjzCoY34kM04ykMDI_CH5sWkEnwWLI"
let token = null 

const savedToken = localStorage.getItem("token") 
if (savedToken != null) {
    token = savedToken
}

export default token 